import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../common/SearchComponent';

class SearchFilterCollection extends SearchComponent {
  searchInputs = [
    {
      label: 'common:label.startDate',
      name: 'startDate',
      type: 'date',
      isClearable: true,
    },
    {
      label: 'common:label.status',
      name: 'status',
      tOptions: 'selections:statusCollections',
      type: 'select',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-6';
}

SearchFilterCollection.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

SearchFilterCollection.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(SearchFilterCollection);
